<template>
  <svg
    class="p-pine"
    :width="size"
    :height="size * 1.2"
    viewBox="0 0 200 240"
    fill="none"
    aria-hidden="true"
  >
    <!-- Leaves -->
    <g>
      <path d="M100 25 Q88 50 92 85 Q100 70 108 85 Q112 50 100 25 Z" fill="#7BB073" />
      <path d="M75 45 Q70 75 88 92 Q85 70 92 55 Q82 45 75 45 Z" fill="#4F8A5C" />
      <path d="M125 45 Q130 75 112 92 Q115 70 108 55 Q118 45 125 45 Z" fill="#4F8A5C" />
      <path d="M62 70 Q66 88 86 95 Q78 82 80 72 Q70 65 62 70 Z" fill="#7BB073" />
      <path d="M138 70 Q134 88 114 95 Q122 82 120 72 Q130 65 138 70 Z" fill="#7BB073" />
    </g>

    <!-- Body -->
    <path
      d="M100 90 C50 90 42 130 42 165 C42 205 65 220 100 220 C135 220 158 205 158 165 C158 130 150 90 100 90 Z"
      fill="#FFC93C"
      stroke="#C98A0A"
      stroke-width="2.5"
    />

    <!-- Quilt pattern -->
    <g opacity="0.35" stroke="#E5A91A" stroke-width="1.5" fill="none">
      <path d="M60 130 L80 120 L100 130 L120 120 L140 130" />
      <path d="M60 130 L80 140 L100 130 L120 140 L140 130" />
      <path d="M60 160 L80 150 L100 160 L120 150 L140 160" />
      <path d="M60 160 L80 170 L100 160 L120 170 L140 160" />
      <path d="M60 190 L80 180 L100 190 L120 180 L140 190" />
    </g>

    <!-- Seed dots -->
    <g fill="#E5A91A" opacity="0.55">
      <circle cx="80" cy="130" r="1.5" />
      <circle cx="120" cy="130" r="1.5" />
      <circle cx="100" cy="160" r="1.5" />
      <circle cx="80" cy="190" r="1.5" />
      <circle cx="120" cy="190" r="1.5" />
    </g>

    <!-- Face (default expression: cheerful with closed-up eyes + smile) -->
    <g>
      <!-- Blush -->
      <ellipse cx="75" cy="160" rx="6" ry="3.5" fill="#F5A99B" opacity="0.6" />
      <ellipse cx="125" cy="160" rx="6" ry="3.5" fill="#F5A99B" opacity="0.6" />
      <!-- Eyes (open round) -->
      <circle cx="88" cy="150" r="4" fill="#1F1B14" />
      <circle cx="112" cy="150" r="4" fill="#1F1B14" />
      <circle cx="87" cy="148.5" r="1.2" fill="#fff" />
      <circle cx="111" cy="148.5" r="1.2" fill="#fff" />
      <!-- Mouth -->
      <path d="M92 168 Q100 175 108 168" stroke="#1F1B14" stroke-width="2" fill="none" stroke-linecap="round" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PineCharacter',
  props: {
    size: { type: [String, Number], default: 200 },
  },
};
</script>

<style lang="scss" scoped>
.p-pine {
  display: block;
  filter: drop-shadow(0 8px 18px rgba(31, 27, 20, 0.18));
}
</style>
